"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMarker = exports.CollectionModelDrawableMarkerMutator = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var vector_1 = require("../../../math/vector");
var drawable_1 = require("./drawable");
var marker_offset_drawable_1 = require("./marker.offset.drawable");
var CollectionModelDrawableMarkerMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMarkerMutator, _super);
    function CollectionModelDrawableMarkerMutator(drawable) {
        return _super.call(this, drawable) || this;
    }
    CollectionModelDrawableMarkerMutator.prototype.init = function (markerPoint, labelPoint, type) {
        if (type === void 0) { type = core_api_1.MarkerType.NONE; }
        var labelId = "".concat(this.drawable.id, ":label");
        this.drawable.drawableState.Mutator.create('label', labelId, this.drawable.id);
        var state = this.getValue();
        state.labelId = labelId;
        state.type = type;
        this.setValue(state);
        _super.prototype.setPosition.call(this, markerPoint.x, markerPoint.y);
        var label = this.drawable.label;
        label.Mutator.move(labelPoint.x, labelPoint.y);
    };
    CollectionModelDrawableMarkerMutator.prototype.offset = function (offset) {
        if (!CollectionModelDrawableMarker.isBase(this.drawable)) {
            throw new Error('Cannot set offset on non base marker');
        }
        var baseOffset = this.drawable.drawableState.baseOffset;
        var value = this.getValue();
        value.offset = offset;
        // remove old base offset marker
        if ((value.offset === 0 || value.offset == null) && baseOffset != null) {
            this.drawable.drawableState.Mutator.remove(baseOffset);
        }
        // create new marker
        if (value.offset > 0 && baseOffset == null) {
            this.drawable.drawableState.Mutator.create('offset', marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.DRAWABLE_ID);
            var offsetMarker = this.drawable.drawableState.baseOffset;
            offsetMarker.Mutator.init();
        }
        this.setValue(value);
    };
    CollectionModelDrawableMarkerMutator.prototype.copy = function (from) {
        this.init(from.getVector(), { x: from.label.state.x, y: from.label.state.y });
        var text = from.label.text;
        if (text != null && text.length > 0) {
            this.drawable.label.Mutator.text(text.join('\n'));
        }
    };
    /**
     * Move the drawable to this location
     *
     * **Markers can only be moved vertically**
     *
     * @param x coordinates in pixels
     * @param y coordinates in pixels
     */
    CollectionModelDrawableMarkerMutator.prototype.move = function (x, y) {
        _super.prototype.move.call(this, this.drawable.state.x, y);
    };
    CollectionModelDrawableMarkerMutator.prototype.moveNoBounds = function (x, y) {
        _super.prototype.moveNoBounds.call(this, this.drawable.state.x, y);
    };
    CollectionModelDrawableMarkerMutator.prototype.unlink = function (fieldId) {
        var links = this.drawable.label.links;
        for (var _i = 0, links_1 = links; _i < links_1.length; _i++) {
            var link = links_1[_i];
            if (link.id === fieldId) {
                link.Mutator.manual(null);
            }
        }
    };
    CollectionModelDrawableMarkerMutator.prototype.setType = function (type) {
        var state = this.getValue();
        state.type = type;
        this.setValue(state);
    };
    return CollectionModelDrawableMarkerMutator;
}(drawable_1.CollectionModelDrawableMutator));
exports.CollectionModelDrawableMarkerMutator = CollectionModelDrawableMarkerMutator;
var CollectionModelDrawableMarker = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMarker, _super);
    function CollectionModelDrawableMarker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = CollectionModelDrawableMarker.TAG;
        _this.Mutator = new CollectionModelDrawableMarkerMutator(_this);
        return _this;
    }
    CollectionModelDrawableMarker.state = function (id, parentId) {
        return {
            id: id,
            parentId: parentId,
            tag: 'marker',
            labelId: null,
            type: core_api_1.MarkerType.NONE,
            x: 0,
            y: 0
        };
    };
    CollectionModelDrawableMarker.isMarker = function (t) {
        return t.tag === CollectionModelDrawableMarker.TAG;
    };
    CollectionModelDrawableMarker.isBase = function (t) {
        return CollectionModelDrawableMarker.isMarker(t) && t.state.type === core_api_1.MarkerType.BASE;
    };
    /** Is this marker just a standard marker */
    CollectionModelDrawableMarker.isNone = function (t) {
        return CollectionModelDrawableMarker.isMarker(t) && t.state.type === core_api_1.MarkerType.NONE;
    };
    Object.defineProperty(CollectionModelDrawableMarker.prototype, "state", {
        get: function () {
            var state = this.collectionState.getFieldValue(this.instanceId);
            if (state == null) {
                return null;
            }
            // Markers must always be in the center of the image
            if (this.drawableState.capture != null) {
                state.x = this.drawableState.capture.resolution.width / 2;
            }
            return state;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarker.prototype.destroy = function () {
        delete this.state.pair;
        delete this.state.position;
    };
    CollectionModelDrawableMarker.prototype.getChildDrawable = function (id) {
        var label = this.label;
        if (label.id === id) {
            return label;
        }
        return null;
    };
    Object.defineProperty(CollectionModelDrawableMarker.prototype, "label", {
        get: function () {
            var stateValue = this.state;
            return this.drawableState.getDrawable(stateValue.labelId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarker.prototype, "value", {
        get: function () {
            var state = this.state;
            if (state.type === core_api_1.MarkerType.BASE) {
                return state.offset || 0;
            }
            if (state.type === core_api_1.MarkerType.BASE_OFFSET) {
                return 0;
            }
            return this.calculateValue();
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarker.prototype.getVector = function () {
        var state = this.state;
        return new vector_1.Vector(state.x, state.y);
    };
    CollectionModelDrawableMarker.prototype.calculateM2Px = function (heightMeters) {
        // if a base offset exists, we should use that measurement instead of the base
        var baseMarker = this.drawableState.baseOffset || this.drawableState.base;
        if (baseMarker == null) {
            return null;
        }
        var baseMarkerXY = baseMarker.getVector();
        var moveVector = new vector_1.Vector(0, -heightMeters);
        var moveDistance = this.drawableState.collection.state
            .getGeometry(this.captureId)
            .movePoint(baseMarkerXY, moveVector);
        return moveDistance;
    };
    CollectionModelDrawableMarker.prototype.calculateValue = function () {
        var baseMarker = this.drawableState.base;
        if (baseMarker == null) {
            return null;
        }
        var adjustOffset = baseMarker.state.offset || 0;
        var baseMarkerXY = baseMarker.getVector();
        var thisXY = this.getVector();
        var distance = this.drawableState.collection.state
            .getGeometry(this.captureId)
            .calculateDistance(baseMarkerXY, thisXY);
        if (baseMarkerXY.y < thisXY.y) {
            return adjustOffset - distance;
        }
        return adjustOffset + distance;
    };
    CollectionModelDrawableMarker.prototype.verticalDistanceFromLaser = function () {
        // laser point is assumed to be in the center of the image
        var centerHeight = this.collectionState.getCapture(this.captureId).resolution.height / 2;
        var markerHeight = this.getVector().y;
        var distance = this.drawableState.collection.state
            .getGeometry(this.captureId)
            .calculateWorldDifferenceVector(new vector_1.Vector(0, markerHeight), new vector_1.Vector(0, centerHeight)).y;
        return distance;
    };
    Object.defineProperty(CollectionModelDrawableMarker.prototype, "altitude", {
        get: function () {
            return this.collectionState.getCapture(this.captureId).target.altitude + this.verticalDistanceFromLaser();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarker.prototype, "isDeletable", {
        get: function () {
            return this.state.type === core_api_1.MarkerType.NONE;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarker.TAG = 'marker';
    return CollectionModelDrawableMarker;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableMarker = CollectionModelDrawableMarker;
//# sourceMappingURL=marker.drawable.js.map